import React from 'react'

function Disclaimer() {
  return (
    <section id="services" className="services">
    <div className="container">
      <header className="section-header">
        <p>Disclaimer</p>
      </header>

      <div className="row">
        <div className="col-12">
          <div className="fortHeadingTerm">Disclaimer of Warranties</div>
          <p className="termP">
            Our Services are provided "as is," and we disclaim all warranties.
            We are not liable for any indirect or incidental damages.
          </p>
          <div className="fortHeadingTerm">Copyright Complaints</div>
          <p className="termP">
            If you believe your intellectual property rights have been
            infringed, contact us.
          </p>
          <div className="fortHeadingTerm">General Terms</div>
          <p className="termP">
            You may not assign your rights under these Terms. We may update
            these Terms from time to time with notice. <br />
            By using our Services, you agree to abide by these Terms. If you
            have any questions, please contact us.
          </p>
        </div>
      </div>
    </div>
  </section>
  )
}

export default Disclaimer